import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";
import { SITE_URL, OG_IMAGE } from "@/lib/site-data";
import { breadcrumbLd, webPageLd } from "@/lib/seo";

const title = "About JTB Floors — 35 Years of Flooring Craftsmanship";
const description =
  "BBB accredited JTB Floors brings 35 years of flooring experience to Barrington, IL and a 35-mile radius, with a 100% labor satisfaction guarantee.";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_URL}/about` },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/about` }],
    scripts: [breadcrumbLd("About", "/about"), webPageLd("AboutPage", title, description, "/about")],
  }),
  component: About,
});
